import { Badge } from "react-bootstrap";

import BadgeEstados from "../../../components/BadgeEstado";
import AccionesActaTable from "../../../views/Acciones/AccionesActaTable";
import HeaderColumn from "../components/HeaderColumn";

export const tableData = (
  data,
  setFiltersField,
  setOrder,
  setOrderField,
  estado_id,
  setActaAImprimir
) => {
  const columns = [
    { field: "id", headerName: "ID", hide: true },
    {
      field: "fecha_hora",
      headerName: "Fecha Hora",
      minWidth: 150,
      flex: 1,
      //   sortable: false,
      //   renderHeader: () => {
      //     return (
      //       <HeaderColumn
      //         setFiltersField={setFiltersField}
      //         setOrder={setOrder}
      //         setOrderField={setOrderField}
      //         typeInput={"text"}
      //         field={"fecha_hora"}
      //         place={"Fecha"}
      //       />
      //     );
      //   },
    },
    {
      field: "numero_acta",
      headerName: "Acta",
      minWidth: 120,
      flex: 2,
      //   sortable: false,
      //   renderHeader: () => {
      //     return (
      //       <HeaderColumn
      //         setFiltersField={setFiltersField}
      //         setOrder={setOrder}
      //         setOrderField={setOrderField}
      //         typeInput={"number"}
      //         field={"numero_acta"}
      //         place={"Acta"}
      //       />
      //     );
      //   },
    },
    ...(estado_id == 12
      ? [
          {
            field: "motivo",
            headerName: "Motivo",
            minWidth: 160,
            flex: 2,
            // sortable: false,
            // renderHeader: () => {
            //   return (
            //     <HeaderColumn
            //       setFiltersField={setFiltersField}
            //       setOrder={setOrder}
            //       setOrderField={setOrderField}
            //       typeInput={"select"}
            //       field={"motivo"}
            //       place={"Motivo"}
            //     />
            //   );
            // },
            renderCell: (params) => {
              return (
                <>
                  <Badge bg="danger">{params?.row?.motivo}</Badge>
                </>
              );
            },
          },
        ]
      : []),
    {
      field: "infraccion",
      headerName: "Infraccion",
      minWidth: 150,
      flex: 2,
      //   sortable: false,
      //   renderHeader: () => {
      //     return (
      //       <HeaderColumn
      //         setFiltersField={setFiltersField}
      //         setOrder={setOrder}
      //         setOrderField={setOrderField}
      //         typeInput={"select"}
      //         field={"tipo"}
      //         place={"Tipo"}
      //       />
      //     );
      //   },
    },
    {
      field: "plate",
      headerName: "Patente",
      minWidth: 150,
      flex: 2,
      //   sortable: false,
      //   renderHeader: () => {
      //     return (
      //       <HeaderColumn
      //         setFiltersField={setFiltersField}
      //         setOrder={setOrder}
      //         setOrderField={setOrderField}
      //         typeInput={"text"}
      //         field={"plate"}
      //         place={"Patente"}
      //       />
      //     );
      //   },
    },
    {
      field: "localidad",
      headerName: "Localidad",
      minWidth: 170,
      flex: 2,
      //   sortable: false,
      //   renderHeader: () => {
      //     return (
      //       <HeaderColumn
      //         setFiltersField={setFiltersField}
      //         setOrder={setOrder}
      //         setOrderField={setOrderField}
      //         typeInput={"text"}
      //         field={"localidad"}
      //         place={"Localidad"}
      //       />
      //     );
      //   },
    },
    {
      field: "documento",
      headerName: "Documento",
      minWidth: 160,
      flex: 2,
      //   sortable: false,
      //   renderHeader: () => {
      //     return (
      //       <HeaderColumn
      //         setFiltersField={setFiltersField}
      //         setOrder={setOrder}
      //         setOrderField={setOrderField}
      //         typeInput={"number"}
      //         field={"documento_titular"}
      //         place={"Documento"}
      //       />
      //     );
      //   },
    },

    {
      field: "estado",
      headerName: "Estado",
      minWidth: 200,
      flex: 2,
      //   sortable: false,
      //   renderHeader: () => {
      //     return (
      //       <HeaderColumn
      //         setFiltersField={setFiltersField}
      //         setOrder={setOrder}
      //         setOrderField={setOrderField}
      //         typeInput={"select"}
      //         field={"estado_id"}
      //         place={"Estado"}
      //       />
      //     );
      //   },
      renderCell: (params) => {
        return (
          <>
            <BadgeEstados estado_id={params.row.estado} />
          </>
        );
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      minWidth: 100,
      flex: 1,
      renderCell: (params) => {
        return (
          <>
            <AccionesActaTable
              id={params.row.id}
              estado_id={params.row.estado}
              alertas={params.row.alertas}
              actaFisica={params.row.get_acta_fisica}
              acta={params.row}
              setActaAImprimir={setActaAImprimir}
              user_id_asignado={params.row.user_id_asignado}
              estado={estado_id}
            />
          </>
        );
      },
    },

    ...(estado_id === 8 || estado_id == 4 || estado_id == 11
      ? [
          {
            field: "notificador_nombre",
            headerName: "Notificador",
            minWidth: 300,
            flex: 2,
            sortable: false,
            renderHeader: () => {
              return (
                <HeaderColumn
                  setFiltersField={setFiltersField}
                  setOrder={setOrder}
                  setOrderField={setOrderField}
                  typeInput={"text"}
                  field={"notificador"}
                  place={"Notificador"}
                />
              );
            },
            renderCell: (params) => {
              return (
                <>
                  <span
                    className={`${params.row.tipo_acta_generada == "DIGITAL" ? "  px-2 rounded fw-bold" : params.row.notificador_nombre ? "" : "text-danger"}`}
                  >
                    {params.row.tipo_acta_generada == "DIGITAL"
                      ? "Mi Muni Digital"
                      : params.row.notificador_nombre
                        ? params.row.notificador_nombre
                        : "No tiene notificador"}
                  </span>
                </>
              );
            },
          },
        ]
      : []),

    // {
    //   field: "actions",
    //   headerName: "Acciones",
    //   minWidth: 120,
    //   flex: 1,
    //   renderCell: (params) => {
    //     return (
    //       <AccionesActaTable
    //         id={params.row.id}
    //         estado_id={params.row.estado}
    //         alertas={params.row.alertas}
    //         actaFisica={params.row.get_acta_fisica}
    //         acta={params.row}
    //         setActaAImprimir={setActaAImprimir}
    //         user_id_asignado={params.row.user_id_asignado}
    //         estado={estado_id}
    //       />
    //     );
    //   },
    // },
  ];

  const rows = data.map((d, index) => {
    // console.log(d);
    return {
      id: d?.id,
      fecha_hora: d?.fecha_hora,
      numero_acta: d?.numero_acta,
      infraccion: d?.tipo,
      plate: d?.plate,
      localidad: d?.localidad,
      documento: d?.documento_titular,
      get_acta_fisica: d.get_acta_fisica,
      user_id_asignado: estado_id == 8 ? d?.notificadores[0]?.user_id_asignado : null,
      notificador_nombre:
        estado_id == 8 || estado_id == 4 ? d?.notificadores[0]?.persona.nombre : null,
      estado: d?.estado_id,
      alertas: d?.alertas,
      motivo: estado_id == 12 ? d?.motivo?.estado?.nombre : null,
      tipo_acta_generada:
        estado_id == 8 || estado_id == 4 || estado_id == 11 ? d.tipo_acta_generada : null,
      dependencia: d?.dependencia,
      domicilio_notificacion_id: d?.domicilio_notificacion_id,
    };
  });

  const filter = (d, value) => {
    value = value.toLowerCase();

    return (
      String(d.id)?.toString().toLowerCase().includes(value) ||
      String(d.plate)?.toString().toLowerCase().includes(value) ||
      String(d.fecha_hora)?.toString().toLowerCase().includes(value) ||
      String(d.infraccion)?.toString().toLowerCase().includes(value) ||
      String(d.documento)?.toString().toLowerCase().includes(value) ||
      String(d.localidad)?.toString().toLowerCase().includes(value) ||
      String(d.numero_acta)?.toString().toLowerCase().includes(value) ||
      String(d.numero_acta)?.toString().toLowerCase().includes(value)
    );
  };

  return { columns, rows, filter };
};
